module.exports = [{
      plugin: require('/Users/ehermanson/projects/react-boston/2019/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
